/* eslint-disable no-unused-vars */
import React from 'react';

import Icon from '@components/icon-component';
import TaskStatusAndPriority from '@components/task-status-priority';
import Checkbox from '@components/checkbox/checkbox.component';
import HighlightText from '@components/highlight-text';

import style from './header.module.scss';
import useWindowDimensions from '@hooks/useWindowDimensions';

const CardHeader = ({
  iconName,

  title,
  status,
  highlight,
  checkbox,
  syncedIcon,
  type,
  link,
  selected,
  setSelected,
  openModal,
  formWrapper
}) => {
  const { width } = useWindowDimensions();
  return (
    <>
      <div className={style.headerClass}>
        <div className={style.leftDiv}>
          <Icon height={15} width={15} name={iconName} />
          <p>
            <HighlightText text={title} highlight={highlight} />

            {link && width > 600 && (
              <span className={`${status === 'To do' && style.link}`}>
                <a href={link} rel="noreferrer">
                  <Icon
                    height={18}
                    width={18}
                    name="link"
                    onClick={(e) => {
                      e?.stopPropagation();
                      console.log('click on new link');
                      // window.open(link, '_blank');
                    }}
                  />
                </a>
              </span>
            )}
          </p>

          {/* {link && width > 600 && (
            <span className={`${status === 'To do' && style.link}`}>
              <a href={link} rel="noreferrer">
                <Icon
                  height={18}
                  width={18}
                  name="link"
                  onClick={(e) => {
                    e?.stopPropagation();
                    console.log('click on new link');
                    // window.open(link, '_blank');
                  }}
                />
              </a>
            </span>
          )} */}

          {syncedIcon && <Icon height={20} width={20} name="attachment" />}
        </div>
        <div
          className={style.rightDiv}
          style={{
            gap: status === 'To do' && type !== 'Check' ? '5px' : '',
            minWidth: status === 'To do' && type !== 'Check' ? '70px' : ''
          }}
        >
          <TaskStatusAndPriority status={status} openModal={openModal} formWrapper={formWrapper} />
          {checkbox && status === 'To do' && type !== 'Check' ? (
            <Checkbox
              checked={selected}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => setSelected(e.target.checked)}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default CardHeader;
